import HomePage from "@/page/HomePage.vue";
import LogsPage from "@/page/LogsPage.vue";
import AuthForgotPage from "@/page/AuthForgotPage.vue";
import AuthRegistrationPage from "@/page/AuthRegistrationPage.vue";
import NotFound from "@/page/NotFound.vue";
import EventsPage from "@/page/EventsPage.vue";
import HealthCheckPage from "@/page/HealthCheckPage.vue";
import SettingsPage from "@/page/SettingsPage.vue";
import ProfilePage from "@/page/ProfilePage.vue";

import {createRouter, createWebHistory} from "vue-router";
import UserListPage from "@/page/Admin/UserListPage.vue";
import TariffListPage from "@/page/Admin/TariffListPage.vue";
import AuthRecoveryPage from "@/page/AuthRecoveryPage.vue";
import AccountListPage from "@/page/Admin/AccountListPage.vue";
import AdminState from "@/page/Admin/AdminState.vue";
import BalancePage from "@/page/BalancePage.vue";

const routes = [
    {
        path: '',
        name: 'home',
        meta: {
            title: 'Dashboard',
        },
        component: HomePage,
    },
    {
        path: '/logs',
        name: 'logs',
        meta: {
            title: 'Логи',
        },
        component: LogsPage,
    },
    {
        path: '/events',
        name: 'events',
        meta: {
            title: 'События',
        },
        component: EventsPage,
    },
    {
        path: '/health-check',
        name: 'health-check',
        meta: {
            title: 'Health Check',
        },
        component: HealthCheckPage,
    },
    {
        path: '/settings',
        name: 'settings',
        meta: {
            title: 'Настройки',
        },
        component: SettingsPage,
    },
    {
        path: '/profile',
        name: 'profile',
        meta: {
            title: 'Профиль',
        },
        component: ProfilePage,
    },
    {
        path: '/admin/tariff',
        name: 'admin-tariff',
        meta: {
            title: 'Тарифы',
        },
        component: TariffListPage,
    },
    {
        path: '/admin/users',
        name: 'admin-users',
        meta: {
            title: 'Пользовтели',
        },
        component: UserListPage,
    },
    {
        path: '/admin/accounts',
        name: 'admin-accounts',
        meta: {
            title: 'Аккаунты',
        },
        component: AccountListPage,
    },
    {
        path: '/admin/state',
        name: 'admin-state',
        meta: {
            title: 'Состояние сервиса',
        },
        component: AdminState,
    },
    {
        path: '/forgot',
        name: 'forgot',
        meta: {
            offAuth: true,
        },
        component: AuthForgotPage,
    },
    {
        path: '/recovery',
        name: 'recovery',
        meta: {
            title: 'Новый пароль',
            offAuth: true,
        },
        component: AuthRecoveryPage,
    },
    {
        path: '/registration',
        name: 'registration',
        meta: {
            offAuth: true,
        },
        component: AuthRegistrationPage,
    },
    {
        path: '/balance',
        name: 'balance',
        meta: {
            offAuth: false,
        },
        component: BalancePage,
    },
    {
        path: '/:pathMatch(.*)*',
        name: '404',
        component: NotFound
    }
];

const router = createRouter({
    routes: routes,
    history: createWebHistory()
})

export default router;